// React
import React, { useEffect, useRef, useState } from "react";

// Libraries
import PropTypes from "prop-types";
import AudioPlayer from "react-h5-audio-player";
import { Loader } from "semantic-ui-react";

// Redux
import { connect } from "react-redux";
import downloadFile from "@Actions/downloads";

// Utils
import { isRemoteMediaUri } from "@Utils";

// Styles
import styles from "./styles.module.css";

const AudioContent = ({ dispatch, item }) => {
	const [isDownloading, setIsDownloading] = useState(false);
	const [fileUri, setFileUri] = useState(null);
	const cachedFileUriRef = useRef(null);

	useEffect(() => {
		const { uri } = item;
		let cancelled = false;

		(async () => {
			if (cachedFileUriRef.current) {
				setFileUri(cachedFileUriRef.current);
				setIsDownloading(false);
				return;
			}

			if (isRemoteMediaUri(uri)) {
				setIsDownloading(true);
				const file = await dispatch(downloadFile({ uri }));
				if (cancelled) return;
				if (file) {
					cachedFileUriRef.current = file;
					setFileUri(file);
				}
				setIsDownloading(false);
				return;
			}

			setFileUri(uri);
			setIsDownloading(false);
		})();

		return () => {
			cancelled = true;
		};
	}, [item.id, item.uri, dispatch]);

	useEffect(() => {
		return () => {
			if (cachedFileUriRef.current) {
				URL.revokeObjectURL(cachedFileUriRef.current);
				cachedFileUriRef.current = null;
			}
		};
	}, [item.id]);

	return (
		<div className={styles.audio}>
			{isDownloading && <Loader inline active size="small" />}
			{!isDownloading && (
				<AudioPlayer
					src={fileUri}
					timeFormat="auto"
					volume={1.0}
					autoPlayAfterSrcChange={false}
					showJumpControls={false}
					layout="horizontal-reverse"
					customAdditionalControls={[]}
					customVolumeControls={[]}
				/>
			)}
		</div>
	);
};

AudioContent.propTypes = {
	dispatch: PropTypes.func,
	item: PropTypes.object,
};

export default connect()(AudioContent);
